import {useCookies} from 'react-cookie';

import {
  AFFID_COOKIE_NAME,
  CONSENT_GROUPS_QUERY_PARAM,
  MARKET,
  TIDE_WEB_APP_BASE_ADDRESS,
} from '@fo/shared-types/constants';
import {isBrowser} from '@fo/shared/utils/browserSupport';
import useHandleLandingUrl from '@fo/shared-hooks/useHandleLandingUrl';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';

export enum ESource {
  ADVISOR = 'fc-connect-advisor',
  ADVISOR_CLIENT = 'fc-connect-client-first-quote',
  BRS = 'fo-brs-referral',
  CONVERSION_PAGE = 'tide-onboarding-fo-conversion',
  CREATE_ACCOUNT = 'tide-onboarding-fo-create-account',
  FROM_CTA_TO_GET_STARTED = 'tide-onboarding-fo-get-started-cta',
  LANDED_ON_GET_STARTED = 'tide-onboarding-fo-get-started',
  PARTNER_PAGE = 'tide-onboarding-fo-partner',
  TSB = 'fo-partner-tsb',
}

interface RedirectToTideProps {
  requestedAmount?: string;
  financePurpose?: string;
  isMandatoryOB?: boolean;
  source: string;
  ldABConversionFlag?: {
    flags?: ObjectOfAny;
  };
}

type UseRedirectToTide = {
  redirectToTide(props: RedirectToTideProps): Promise<void>;
};

export const useRedirectToTide = (): UseRedirectToTide => {
  const [cookies] = useCookies();
  const landingUrl = useHandleLandingUrl();

  const redirectToTide = async ({
    requestedAmount = '',
    financePurpose = '',
    isMandatoryOB = false,
    source = '',
    ldABConversionFlag,
  }: RedirectToTideProps) => {
    const formOrigin = isBrowser ? window.encodeURIComponent(window.location.href) : '';
    // before encoding to send it as a query parameter, we try to decode it to remove any prior encoding
    // this is due to some urls coming from campaigns to potentially have mixed encoded/not encoded parts
    const encodedLandingUrl = landingUrl ? window.encodeURIComponent(window.decodeURIComponent(landingUrl)) : undefined;
    const foid = window.FOID || '';
    const affid = cookies[AFFID_COOKIE_NAME];
    // eslint-disable-next-line no-underscore-dangle
    const segmentAnonymousId = window.fundingOptions.segment?.instance?._user?.anonymousId() || '';

    const tideQuoteFormUrl = `${TIDE_WEB_APP_BASE_ADDRESS}/funding-cloud/onboarding/finance-information`;

    const paramsAsString = `landing_url=${encodedLandingUrl}&fo_form_origin=${formOrigin}&requested_amount=${requestedAmount}&finance_purpose=${financePurpose}&market=${MARKET}&source=${source}&ob=${isMandatoryOB}&foid=${foid}&affid=${affid}&said=${segmentAnonymousId}&${CONSENT_GROUPS_QUERY_PARAM}=${window.OnetrustActiveGroups}`;
    if (isBrowser) {
      track(segmentEvents.actions.redirectToTide, {
        formOrigin,
        landingUrl: landingUrl || '',
        isMandatoryOB: isMandatoryOB.toString() || '',
        source,
        requestedAmount,
        financePurpose,
        market: MARKET,
        featureFlags: ldABConversionFlag,
      });
      window.open(`${tideQuoteFormUrl}?${paramsAsString}`, '_self');
    }
  };

  return {
    redirectToTide,
  };
};
